import {
    Home,
Inbox,
    Outbox,
   DeliveryDining,
    UTurnLeft,


    TipsAndUpdates,
    AddBox,
    List

} from '@mui/icons-material'
import {useNavigate} from 'react-router-dom'
import {useState} from "react";


const Sidebar = () => {

    // keeping track of active page
    const [active, setActive] = useState(0)
    const nav = useNavigate()







    return (
        <>
            <div className="is-flex is-flex-direction-column is-justify-content-start rightmenu p-3 my-3 ">


                <div className={`dashboard__menu ${active === 0 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin');
                    setActive(0)
                }}>

                    <Home/>
                    <h3>داشبورد</h3>
                </div>


                <div className={`dashboard__menu ${active === 1 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin/centers');
                    setActive(1)
                }}>

                    <AddBox/>
                    <h3>ثبت بسته جدید</h3>
                </div>


                <div className={`dashboard__menu ${active === 2 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin/parcel-in');
                    setActive(2)
                }}>

                    <Inbox/>
                    <h3>ورود مرسوله به مرکز پستی (گذر)</h3>
                </div>

                <div className={`dashboard__menu ${active === 3 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin/parcel-out');
                    setActive(3)
                }}>

                    <Outbox/>
                    <h3>خروج مرسوله از مرکز پستی (گذر)</h3>
                </div>

                <div className={`dashboard__menu ${active === 4 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin/parcel-delivered');
                    setActive(4)
                }}>

                    <DeliveryDining/>
                    <h3>تحویل مرسوله به مشتری</h3>
                </div>

                <div className={`dashboard__menu ${active === 7 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin/parcel-return');
                    setActive(7)
                }}>

                    <UTurnLeft/>
                    <h3>مرجوع کردن مرسوله</h3>
                </div>


                <div className={`dashboard__menu ${active === 6 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin/parcel-list');
                    setActive(6)
                }}>

                    <List/>
                    <h3>گزارشات و لیست مرسوله ها</h3>
                </div>


                <div className={`dashboard__menu ${active === 5 && 'dashboardActive'}`} onClick={() => {
                    nav('/admin/about');
                    setActive(5)
                }}>
                    <TipsAndUpdates/>
                    <h3> راهنمای پنل</h3>
                </div>


            </div>

        </>
    )
}
export default Sidebar;